import {
    Button,
    Grid,
    setRef,
    Typography
} from "@mui/material";
import {
    useEffect,
    useRef,
    useState
} from "react";
import {
    AddAerosol,
    AddBassin,
    AddContact,
    Aerosol,
    AerosolDetail,
    Contact,
    ContactDetail,
    DeactivateAerosolCommand,
    DeactivateContactCommand,
    Delete,
    IGStyle,
    UpdateAerosol,
    UpdatePool
} from "../../constants";
import {useZINContext} from "../../context/ZinContextProvider";
import {submitObject} from "../../util";

const AerosolBlock = () =>
{
    const {
        poolDetails,
        poolDSLFilter,
        setFormData,
        setModalVisible,
        setModalAction,
        refreshResource, setRefreshResource, setAlertVisible, setAlertText,setDeleteCallback
    } = useZINContext()

    const RMRef = useRef<any>()
    const RDRef = useRef<any>()
    const [detailStatus, setDetailStatus] = useState<any>(false)
    const [detailRecord, setDetailRecord] = useState<any>("")

    useEffect(() =>
    {
        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setFormData(event.detail.record)
            setDetailStatus(true)
            setDetailRecord(event.detail.recordId)
        })
    }, [])

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case Aerosol:
                setTimeout(() => RMRef.current?.refresh(), 1000)
                break
            case AerosolDetail:
                setTimeout(() => RDRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function ResetDetailStatus()
    {
        setRefreshResource(Aerosol)
        setDetailStatus(false)
    }

    function AerosolToevoegen()
    {
        setFormData(undefined)

        setModalVisible(true)
        setModalAction(AddAerosol)
    }
    function AerosolBewerken(){
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(UpdateAerosol)
    }
    const handleStartDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
        setModalVisible(true)
        setModalAction(Delete)
        setDeleteCallback({delete: DeleteObject} )
    };
    function DeleteObject(){
        submitObject({id: RDRef.current?.data.id},  poolDetails?.id, DeactivateAerosolCommand).then(async (event: any) =>
        {
            HandleSubmit(event)
        })

        setDetailStatus(false)
        setRefreshResource(Aerosol)
    }
    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status !== 200){
            const response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }
    }


    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Aerosol Elementen
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>

                    <div style={{
                        display: detailStatus
                                 ? "contents"
                                 : "none"
                    }}>
                        <Button className={"od-button"} onClick={ResetDetailStatus}>Back</Button>
                        {/*// @ts-ignore*/}
                        <ig-resource-detail lang="nl-NL" ref={RDRef} class={"od-table-resource ig-detail-remove-2rows"} style={IGStyle} resource-detail-id="AerosolElementRD" resource-id={detailRecord}/>
                    </div>
                    <div style={{
                        display: detailStatus
                                 ? "none"
                                 : "contents"
                    }}>                     {/*// @ts-ignore*/}
                        <ig-resource-master lang="nl-NL" ref={RMRef} style={IGStyle} class={"od-table-master ig-columns"} resource-master-id="AerosolElementRM" dsl-filter={poolDSLFilter}/>
                    </div>


                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid item xs={4}>
                        <Grid container direction="column" item>
                            <Button className={detailStatus? "":"od-button"} variant={"contained"} disabled={detailStatus} onClick={AerosolToevoegen}>Aerosol Toevoegen</Button>
                            <Button className={!detailStatus? "":"od-button"} variant={"contained"} disabled={!detailStatus}  onClick={AerosolBewerken}>Aerosol Bewerken</Button>
                            <Button className={!detailStatus? "":"od-button"} variant={"contained"} disabled={!detailStatus}  onClick={handleStartDelete}>Aerosol Verwijderen</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default AerosolBlock